import React from 'react';
import Joi from 'joi-browser';
import Form from '../../../common/form';
import Spinner from '../../../common/spinner';

class GetUserByUIDForm extends Form {
	state = {
		data: {
			uid: '',
		},
		errors: {},
	};

	schema = {
		uid: Joi.string().min(8).max(10).required().label('ID'),
	};

	doSubmit = () => this.props.onSubmit(this.state.data);

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, theme } = this.props;

		return (
			<form
				className='row'
				onSubmit={this.handleSubmit}>
				<div className='col-md-6 offset-md-3 col-12 text-start'>
					<div className='mt-4'>
						{this.renderInput({
							name: 'uid',
							label: 'UID',
							type: 'text',
						})}
					</div>

					<div className='my-3 text-center'>
						{this.renderButton(
							'Get user by ID',
							`btn btn-set2-${theme} w-100`,
							isLoading && <Spinner content='Loading...' />
						)}
					</div>
				</div>
			</form>
		);
	}
}

export default GetUserByUIDForm;
